require('./transfersTableInfoRow.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classNames = require('classnames');
const {connect} = require('react-redux');
// @ actions
const receivedTransfersDetails = require('actions/receivedTransfersDetails');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ constants
const { getTranslatedCountry } = require('constants/countries');

class TransfersTableInfoRow extends React.Component {
    constructor(props) {
        super(props);

        this.buildLoadingSection = this.buildLoadingSection.bind(this);
        this.buildDetailsSection = this.buildDetailsSection.bind(this);
    }
    componentDidMount() {
        const { getDetails, immTransaction } = this.props;
        getDetails(immTransaction);
    }

    buildDetailsSection() {
        const { immScreen } = this.props;
        const isMobile = immScreen.get('isMobile');

        let tableRowTitle = 'transfersEmited-detailInformation';
        let tableRowColumns = 2;

        if (isMobile) {
            tableRowColumns = 1;
            tableRowTitle = '';
        }

        if (!this.props.immTransaction.get('details') || this.props.immTransaction.get('fetchingDetails')){
            return;
        }

        const transferInfo = this.transferInfo();

        return (
            <OKTableRowDetails
                isMobile={isMobile}
                title={tableRowTitle}
                columns={tableRowColumns}
            >
                {transferInfo}
            </OKTableRowDetails>
        );
    }

    buildLoadingSection() {
        if (this.props.immTransaction.get('fetchingDetails')){
            return (<LoadingSection />);
        }
    }

    transferInfo() {
        const {
            immScreen,
            immTransaction,
        } = this.props;

        const isMobile = immScreen.get('isMobile');
        const immDetails = immTransaction.get('details');
        const items = [
            {
                label: formatText('transfersReceived-beneficiary'),
                value: immDetails.get('beneficiary') || '-',
            },
            {
                label: formatText('transfersReceived-transferExpenses'),
                value: immDetails.get('transferExpenses') ? <FormattedText value="transfersReceived-transferExpensesValue" apiValue={immDetails.get('transferExpenses')} /> : '-',
            },
            {
                label: formatText('transfersReceived-concept'),
                value: immDetails.get('concept') || '-',
            },
            {
                label: formatText('transfersReceived-transferType'),
                value: immDetails.get('transferType') ? <FormattedText value="transfersReceived-transferTypeValue" apiValue={immDetails.get('transferType')} /> : '-',
            }
        ];

        //If mobile removes cell with immDetails.get('beneficiary') value
        if (isMobile) {
            items.splice(0, 1);
        }

        if (!immTransaction.get('isPass')) {
            items.push(
                {
                    label: formatText('transfersReceived-payer'),
                    value: immDetails.get('payer') || '-',
                },
                {
                    label: formatText('transfersReceived-emissorBank'),
                    value: `${immDetails.getIn(['officeBank', 'enterprise'])} ${immDetails.getIn(['officeBank', 'center'])} (${immDetails.get('emissorBank')})`,
                },
                {
                    label: formatText('transfersReceived-originCountry'),
                    value: getTranslatedCountry(immDetails.get('originCountry'))
                }
            );
        }

        return items.map(({label, value}, index) => (
            <OKTableRowDetailsItem
                key={`firstColumnTransferInfo-${index}`}
                title={label}
                value={value}
            />
        ));
    }

    render() {
        const {
            id,
            immScreen,
        } = this.props;

        const detailsSection = this.buildDetailsSection();
        const loadingSection = this.buildLoadingSection();
        const sectionClasses = classNames(
            'transfers-table-info-row',
            {'transfers-table-info-row--mobile' : immScreen.get('isMobile')}
        );

        return (
            <OKTableRow id={id}>
                <OKTableCell colSpan={7}>
                    <section className={sectionClasses}>
                        {loadingSection}
                        {detailsSection}
                    </section>
                </OKTableCell>
            </OKTableRow>
        )
    }
}

TransfersTableInfoRow.propTypes = {
    getDetails: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
}

module.exports.constructor = TransfersTableInfoRow;
module.exports.TransfersTableInfoRow = connect(
    state => ({
        immScreen: state.screen,
    }),
    {
        getDetails: receivedTransfersDetails.getDetails
    }
)(TransfersTableInfoRow);